import axios from 'axios';
import { responseInterceptor, errorInterceptor } from './interceptors';

const getStoredToken = () => {
  const tokenFromLocalStorage = localStorage.getItem('APP_ACCESS_TOKEN');
  if (!tokenFromLocalStorage) return '';

  try {
    return JSON.parse(tokenFromLocalStorage);
  } catch {
    localStorage.removeItem('APP_ACCESS_TOKEN');
    return '';
  }
};

const storedToken = getStoredToken();
const authorizationHeader = storedToken ? `Bearer ${storedToken}` : '';

const ApiLogin = axios.create({
  baseURL: window.env.REACT_APP_URL_BASELOGIN,
  headers: {
    Authorization: authorizationHeader
  }
  
});

ApiLogin.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);

export { ApiLogin };